import ContainedImage from '../elements/ContainedImage';
import Icon from '../elements/icons/Icon';
import Link from '../elements/Link';
import React from 'react';

const UserLogo = props => {
    const {user, profileUrl = '/my_profile'} = props;

    return (
        <div
            className="text-center"
            style={{
                padding: 20,
            }}>
            <ContainedImage
                className="avatar"
                src={user.image_url}
                style={{
                    width: 72,
                    height: 72,
                    display: 'inline-block',
                    borderRadius: 36,
                }}
            />
            <p
                style={{
                    fontSize: 14,
                    paddingTop: 9,
                }}>
                {user.first_name}
                &nbsp; {user.last_name}
                &nbsp; &nbsp;
                <Link href={profileUrl}>
                    <Icon
                        icon="edit"
                        size={24}
                        style={{
                            opacity: 0.3,
                            verticalAlign: 'top',
                        }}
                    />
                </Link>
            </p>
        </div>
    );
};

export default UserLogo;
